<script>
import RuntimeSettingsAls from './runtime-settings-als.svelte'

export let dx
</script>

<RuntimeSettingsAls bind:dx />
<h4>Agent broker</h4>
<p>Agent-specific node runtime settings will be added here.</p>
